import { 
  // CREATE_HEDGEFUND_AUDITLOGS, 
  GET_SEARCH_ALLOCATORS_ACTION 
} from "./constants";

export const getSearchAllocators = (payload) => {
  return {
    type: GET_SEARCH_ALLOCATORS_ACTION,
    payload,
  };
};